import { useContext } from 'react'
import { Store } from 'store/store'

function useLocale() {
	return useContext(Store).state.languageValue
}

export default useLocale